// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Rx = require("../../rx/Rx.bs.js");
var Axios = require("axios");
var React = require("react");
var Sentry = require("../../Sentry.bs.js");
var V4 = require("uuid/v4");
var Upload = require("./upload").default;
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Core__List = require("@rescript/core/src/Core__List.bs.js");
var ImageUtils = require("../imageUtils/ImageUtils.bs.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var AuthSession = require("../../../utils/AuthSession.bs.js");
var RescriptCore = require("@rescript/core/src/RescriptCore.bs.js");
var AttachmentsApi = require("../../../api/attachmentsApi");

function addFiles(files, t) {
  t.addFiles(files);
}

function observable(t) {
  return t.observable;
}

function make() {
  var subject = Rx.Subject.make();
  var addFiles = function (files) {
    Rx.Observable.Observer.next(files, Rx.Subject.observer(subject));
  };
  var observable = Rx.Subject.observable(subject);
  return {
          addFiles: addFiles,
          observable: observable
        };
}

var FileObserver = {
  addFiles: addFiles,
  observable: observable,
  make: make
};

function uploadFile(prim0, prim1) {
  return AttachmentsApi.uploadFile(prim0, prim1);
}

var UploadFile = {
  uploadFile: uploadFile
};

function sign(token, file) {
  var file_id = file.id;
  var file_name = file.file.name;
  var file_size = file.file.size;
  var file_type = file.file.type;
  var file$1 = {
    id: file_id,
    name: file_name,
    size: file_size,
    type: file_type
  };
  return Rx.Operators.defer(function () {
              return Rx.Observable.fromPromise(AttachmentsApi.uploadFile(token, file$1));
            });
}

function doUpload(prim0, prim1, prim2, prim3) {
  return Upload(prim0, prim1, prim2, prim3);
}

function upload(result, file) {
  var source = Axios.CancelToken.source();
  return Rx.Observable.fromFn(function (emitter) {
              ((function (__x) {
                      return Js_promise.$$catch((function (err) {
                                    Rx.Observable.Emitter.error(err, emitter);
                                    return Promise.resolve();
                                  }), __x);
                    })(doUpload(result, file, source, (function (evt) {
                              if (evt.lengthComputable) {
                                return Rx.Observable.Emitter.next(evt.loaded / evt.total, emitter);
                              }
                              
                            })).then(function () {
                          Rx.Observable.Emitter.complete(emitter);
                          return Promise.resolve();
                        })));
              return Rx.Unsubscriber.make(function () {
                          source.cancel();
                        });
            });
}

var Helpers = {
  UploadFile: UploadFile,
  sign: sign,
  doUpload: doUpload,
  upload: upload
};

function doRenderPreview(param) {
  var file = param.file;
  var onChangePreview = param.onChangePreview;
  var observable = Rx.Single.fromPromise(ImageUtils.resize(240, undefined, file.file));
  ((function (__x) {
          return Rx.Single.subscribeFn((function ($$event) {
                        if ($$event.TAG === "Ok") {
                          return onChangePreview(file.id, $$event._0);
                        } else {
                          return Sentry.captureErrorMessage("Unexpected error rendering the preview", true, undefined, "AttachmentManager.res", 136, {
                                      error: $$event._0,
                                      file: {
                                        name: file.file.name,
                                        type: file.file.type,
                                        size: file.file.size
                                      }
                                    }, undefined, undefined);
                        }
                      }), __x);
        })(observable));
  return observable;
}

function processQueue(state) {
  while(true) {
    var match = state.numRenderers < 5;
    var match$1 = state.queue;
    if (!match) {
      return ;
    }
    if (!match$1) {
      return ;
    }
    state.queue = match$1.tl;
    state.numRenderers = state.numRenderers + 1 | 0;
    ((function (__x) {
            return Rx.Single.subscribeFn((function (param) {
                          state.numRenderers = state.numRenderers - 1 | 0;
                          processQueue(state);
                        }), __x);
          })(doRenderPreview(match$1.hd)));
    continue ;
  };
}

function renderPreview(onChangePreview, file, t) {
  t.queue = Core__List.add(t.queue, {
        onChangePreview: onChangePreview,
        file: file
      });
  processQueue(t);
}

function make$1() {
  return {
          numRenderers: 0,
          queue: /* [] */0
        };
}

var RenderPreview = {
  maxRenderers: 5,
  doRenderPreview: doRenderPreview,
  processQueue: processQueue,
  renderPreview: renderPreview,
  make: make$1
};

function toFile(file) {
  return {
          id: V4(),
          file: file
        };
}

function isImageType(s) {
  return s.startsWith("image");
}

function isImage(attachment) {
  return attachment.file.type.startsWith("image");
}

var supportedMimeTypes = {
  hd: "application/msword",
  tl: {
    hd: "application/pdf",
    tl: {
      hd: "application/rtf",
      tl: {
        hd: "application/vnd.ms-excel",
        tl: {
          hd: "application/vnd.oasis.opendocument.presentation",
          tl: {
            hd: "application/vnd.oasis.opendocument.spreadsheet",
            tl: {
              hd: "application/vnd.oasis.opendocument.text",
              tl: {
                hd: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                tl: {
                  hd: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                  tl: {
                    hd: "image/gif",
                    tl: {
                      hd: "image/jpeg",
                      tl: {
                        hd: "image/png",
                        tl: {
                          hd: "image/webp",
                          tl: {
                            hd: "text/plain",
                            tl: {
                              hd: "text/rtf",
                              tl: {
                                hd: "video/mp4",
                                tl: {
                                  hd: "video/quicktime",
                                  tl: /* [] */0
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

function isSupportedMimeType(mimeType) {
  return Core__List.has(supportedMimeTypes, mimeType, (function (prim0, prim1) {
                return prim0 === prim1;
              }));
}

function isSupportedFile(attachment) {
  return isSupportedMimeType(attachment.file.type);
}

function useAttachmentManager(addFiles, onChangePreview, onUploadProgress, onSigned, onUploadComplete, onUploadError, onUnsupportedFileError) {
  var match = React.useState(function () {
        return {
                numRenderers: 0,
                queue: /* [] */0
              };
      });
  var renderPreview$1 = match[0];
  var fileObserver = make();
  var session = AuthSession.use();
  var fileArrays = Rx.Operators.publish((function (__x) {
            return Rx.Operators.map((function (files) {
                          return Belt_Array.map(files, toFile);
                        }), __x);
          })(fileObserver.observable));
  var match$1 = (function (__x) {
        return Rx.Operators.partition(isSupportedFile, __x);
      })((function (__x) {
            return Rx.Operators.flatMap((function (files) {
                          return Rx.Operators.fromArray(files);
                        }), __x);
          })(fileArrays));
  var supportedFiles = match$1[0];
  ((function (__x) {
          return Rx.Observable.onNext(undefined, undefined, (function (file) {
                        renderPreview(onChangePreview, file, renderPreview$1);
                      }), __x);
        })((function (__x) {
              return Rx.Operators.filter(isImage, __x);
            })(supportedFiles)));
  ((function (__x) {
          return Rx.Observable.onNext(undefined, undefined, onUnsupportedFileError, __x);
        })((function (__x) {
              return Rx.Operators.filter((function (x) {
                            return x.length > 0;
                          }), __x);
            })(Rx.Operators.toArray(match$1[1]))));
  ((function (__x) {
          return Rx.Observable.onNext(undefined, undefined, (function (file) {
                        var tmp;
                        tmp = session !== undefined && session.__typename === "AuthSession" ? session.token : RescriptCore.panic("No token available, cannot upload file.");
                        ((function (__x) {
                                return Rx.Observable.onNext(undefined, (function (err) {
                                              onUploadError(file.id, err);
                                            }), (function (result) {
                                              onSigned(result);
                                              ((function (__x) {
                                                      return Rx.Observable.onNext((function () {
                                                                    onUploadComplete(file.id);
                                                                  }), (function (err) {
                                                                    onUploadError(file.id, err);
                                                                  }), (function (progress) {
                                                                    onUploadProgress(file.id, progress);
                                                                  }), __x);
                                                    })(upload(result, file.file)));
                                            }), __x);
                              })(sign(tmp, file)));
                      }), __x);
        })(supportedFiles));
  ((function (__x) {
          return Rx.Observable.onNext(undefined, undefined, addFiles, __x);
        })(Rx.Operators.toArray(supportedFiles)));
  return function (files) {
    fileObserver.addFiles(files);
  };
}

exports.FileObserver = FileObserver;
exports.Helpers = Helpers;
exports.RenderPreview = RenderPreview;
exports.toFile = toFile;
exports.isImageType = isImageType;
exports.isImage = isImage;
exports.supportedMimeTypes = supportedMimeTypes;
exports.isSupportedMimeType = isSupportedMimeType;
exports.isSupportedFile = isSupportedFile;
exports.useAttachmentManager = useAttachmentManager;
/* Rx Not a pure module */
